export default __webpack_public_path__ + "static/media/MVHUB+-1.0bca3488.png";